/* MERGEsouq header extras (desktop): WhatsApp + Arabic in the top bar, Bulk pricing link in the menu. */
/* Edit the values below to change the number or links. */
(function () {
    var WA = '971547935921';
    var WA_LABEL = 'WhatsApp +971 54 793 5921';
    var AR_URL = '/ar';
    var BULK_LABEL = 'Bulk pricing for clinics';
    var BULK_URL = 'https://wa.me/971547935921?text=Hi%20MERGEsouq%2C%20I%20would%20like%20bulk%20pricing%20for%20my%20clinic';
    var CHAT = '<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M7.9 20A9 9 0 1 0 4 16.1L2 22Z"/></svg>';
    var ARROW = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.25" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12h14"/><path d="m12 5 7 7-7 7"/></svg>';
    function run() {
        var bar = document.querySelector('.announcement-bar');
        if (bar && !bar.querySelector('.ms-ann-right')) {
            var r = document.createElement('div');
            r.className = 'ms-ann-right';
            r.innerHTML = '<a href="https://wa.me/' + WA + '" target="_blank" rel="noopener">' + CHAT + WA_LABEL + '</a>' + '<a href="' + AR_URL + '" lang="ar">&#1575;&#1604;&#1593;&#1585;&#1576;&#1610;&#1577;</a>';
            bar.appendChild(r);
        }
        var nav = document.querySelector('.site-navigation');
        if (nav && !nav.querySelector('.ms-bulk') && !nav.querySelector('a[href*="bulk"]')) {
            var a = document.createElement('a');
            a.className = 'ms-bulk';
            a.href = BULK_URL;
            a.target = '_blank';
            a.rel = 'noopener';
            a.innerHTML = BULK_LABEL + ' ' + ARROW;
            nav.appendChild(a);
        }
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
    else run();
})();

/* Shop by specialty: auto-running category row (phones and tablets) */
(function () {
    function run(el) {
        if (el.__msRun) return;
        if (el.scrollWidth <= el.clientWidth + 4) return;
        el.__msRun = true;
        [].slice.call(el.children).forEach(function (k) { var c = k.cloneNode(true); c.setAttribute('aria-hidden', 'true'); c.setAttribute('tabindex', '-1'); el.appendChild(c); });
        el.style.scrollSnapType = 'none';
        var paused = false, timer = null, pos = el.scrollLeft, last = performance.now();
        function pause() { paused = true; clearTimeout(timer); timer = setTimeout(function () { paused = false; pos = el.scrollLeft; }, 2500); }
        el.addEventListener('touchstart', pause, { passive: true });
        el.addEventListener('mouseenter', function () { paused = true; });
        el.addEventListener('mouseleave', function () { paused = false; pos = el.scrollLeft; });
        function step(now) {
            var dt = now - last; last = now;
            if (dt > 100) dt = 16;
            if (!paused) { pos += dt * 0.04; var half = el.scrollWidth / 2; if (pos >= half) pos -= half; el.scrollLeft = pos; }
            requestAnimationFrame(step);
        }
        requestAnimationFrame(step);
    }
    function init() {
        if (window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches) return;
        document.querySelectorAll('.ms-tiles').forEach(run);
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
    window.addEventListener('load', init);
})();

/* Top sellers tabs: gently run left/right on phones; stops once a tab is tapped */
(function () {
    function pp(el) {
        if (el.__msPP) return;
        if (el.scrollWidth <= el.clientWidth + 4) return;
        el.__msPP = true;
        var dir = 1, paused = false, stopped = false, timer = null, pos = el.scrollLeft, last = performance.now();
        el.addEventListener('touchstart', function () { paused = true; clearTimeout(timer); timer = setTimeout(function () { paused = false; pos = el.scrollLeft; }, 3000); }, { passive: true });
        el.addEventListener('click', function () { stopped = true; });
        el.addEventListener('mouseenter', function () { paused = true; });
        el.addEventListener('mouseleave', function () { paused = false; pos = el.scrollLeft; });
        function step(now) {
            var dt = now - last; last = now;
            if (dt > 100) dt = 16;
            if (!paused && !stopped) { var max = el.scrollWidth - el.clientWidth; pos += dir * dt * 0.03; if (pos >= max) { pos = max; dir = -1; } if (pos <= 0) { pos = 0; dir = 1; } el.scrollLeft = pos; }
            requestAnimationFrame(step);
        }
        requestAnimationFrame(step);
    }
    function init() {
        if (window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches) return;
        document.querySelectorAll('.ms-tabs').forEach(pp);
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
    window.addEventListener('load', init);
})();

/* Install-app pop-up for phones (Android: one-tap install; iPhone: Add to Home Screen tip) */
(function () {
    var KEY = 'ms_install_dismissed';
    function dismissed() { try { var t = +localStorage.getItem(KEY); return t && (Date.now() - t) < 14 * 864e5; } catch (e) { return false; } }
    function standalone() { return (window.matchMedia && matchMedia('(display-mode: standalone)').matches) || navigator.standalone === true; }
    if (standalone() || dismissed() || window.innerWidth >= 750) return;
    var ua = navigator.userAgent, ios = /iphone|ipad|ipod/i.test(ua) && /safari/i.test(ua) && !/crios|fxios|edgios/i.test(ua);
    var deferred = null;
    function show(isIOS) {
        if (document.querySelector('.ms-install')) return;
        var b = document.createElement('div'); b.className = 'ms-install'; b.setAttribute('role', 'dialog'); b.setAttribute('aria-label', 'Install the MERGEsouq app');
        b.innerHTML = '<img src="/cdn/shop/files/Merge_Favicon.png?width=96" alt="">' + '<div class="ms-install__txt"><strong>Get the MERGEsouq app</strong><span>' + (isIOS ? 'Tap the Share icon, then Add to Home Screen' : 'Faster reordering and offers first, from your home screen') + '</span></div>' + (isIOS ? '' : '<button type="button" class="ms-install__btn">Install</button>') + '<button type="button" class="ms-install__x" aria-label="Close">&times;</button>';
        document.body.appendChild(b);
        requestAnimationFrame(function () { requestAnimationFrame(function () { b.classList.add('is-open'); }); });
        function close() { b.classList.remove('is-open'); try { localStorage.setItem(KEY, Date.now()); } catch (e) {} setTimeout(function () { b.remove(); }, 500); }
        b.querySelector('.ms-install__x').addEventListener('click', close);
        var btn = b.querySelector('.ms-install__btn');
        if (btn) btn.addEventListener('click', function () { if (!deferred) return close(); deferred.prompt(); deferred.userChoice.then(function () { deferred = null; close(); }); });
    }
    window.addEventListener('beforeinstallprompt', function (e) { e.preventDefault(); deferred = e; setTimeout(function () { show(false); }, 6000); });
    if (ios) setTimeout(function () { show(true); }, 6000);
    window.addEventListener('appinstalled', function () { var b = document.querySelector('.ms-install'); if (b) b.remove(); });
})();

/* After install: ask customers to allow notifications (asked once) */
(function () {
    if (!('Notification' in window)) return;
    var KEY = 'ms_notif_asked';
    function asked() { try { return !!localStorage.getItem(KEY); } catch (e) { return true; } }
    function mark() { try { localStorage.setItem(KEY, '1'); } catch (e) {} }
    function ask() {
        if (Notification.permission !== 'default' || asked() || document.querySelector('.ms-install')) return;
        var b = document.createElement('div'); b.className = 'ms-install'; b.setAttribute('role', 'dialog'); b.setAttribute('aria-label', 'Turn on offer alerts');
        b.innerHTML = '<img src="/cdn/shop/files/Merge_Favicon.png?width=96" alt="">' + '<div class="ms-install__txt"><strong>Turn on offer alerts?</strong><span>Get new offers and restock news first</span></div>' + '<button type="button" class="ms-install__btn">Allow</button>' + '<button type="button" class="ms-install__x" aria-label="Not now">&times;</button>';
        document.body.appendChild(b);
        requestAnimationFrame(function () { requestAnimationFrame(function () { b.classList.add('is-open'); }); });
        function close() { mark(); b.classList.remove('is-open'); setTimeout(function () { b.remove(); }, 500); }
        b.querySelector('.ms-install__x').addEventListener('click', close);
        b.querySelector('.ms-install__btn').addEventListener('click', function () { Notification.requestPermission().finally(close); });
    }
    window.addEventListener('appinstalled', function () { setTimeout(ask, 1500); });
    var isApp = (window.matchMedia && matchMedia('(display-mode: standalone)').matches) || navigator.standalone === true;
    if (isApp) setTimeout(ask, 4000);
})();
